import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//service
import { setAdminPlusRankingPoints } from "../../../../utils/service/ranking";

function Centers(props) {
  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-centers").focus();
  }, []);
  return (
    <section className="section-centers">
      <a id="title-centers" className="title-home" tabIndex={12}>
        Página Expo Área - GND
      </a>
      <div className="div-cards-centers">
        <div className="card-centers">
          <a className="title-card-centers" tabIndex={13}>
            Studios
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
            onPlay={() => pointAction("GDNVIDEOSTUDIOS")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/EXPO/STAND%20-%20CENTER/Studios.mp4?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=1698236561&Signature=snyl5MLlw4g6FVl%2FCpRA3ICEKZE%3D" />
          </video>
        </div>

        <div className="card-centers">
          <a className="title-card-centers" tabIndex={15}>
            Cícero
          </a>
          <video
            width={250}
            controls
            tabIndex={16}
            onPlay={() => pointAction("GDNVIDEOCICERO")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/%C3%81reas%20Expo%20-%20C%C3%ADcero%20Lopes%20%28GDN-e%20GDN%29%20V2023.mp4" />
          </video>
        </div>

        <div className="card-centers">
          <a className="title-card-centers" tabIndex={17}>
            Virginia
          </a>
          <video
            width={250}
            controls
            tabIndex={18}
            onPlay={() => pointAction("GDNVIDEOVIRGINIA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/%C3%81reas%20Expo%20-%20Virginia%20Cunha%20Heimann%20%28GDN-e%29%20V2023.mp4" />
          </video>
        </div>

        {/* <div className="card-centers">
          <a className="title-card-centers" tabIndex={19}>
            Estrutura Centers
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Baixar pdf Estrutura Centers"
            tabIndex={20}
            onClick={() =>
              window.open(
                "https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/EXPO/STAND%20-%20CENTER/Estrutura%20Centers.pdf?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=1703335387&Signature=xXwu93SzCErcnOAv2NMtgVdEMBI%3D",
                "_blank"
              )
            }
          >
            <i
              className="bx bx-download"
              style={{ fontSize: 40, cursor: "pointer" }}
              id="centers-link"
            />
          </button>
        </div> */}
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(Centers);
